/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_0Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the GridCraft editor and launch the workspace. Choose File → Open and select your test .xlsx file. The web build uses the browser’s file picker; opening a file does not create a shared cloud document.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 GridCraft 编辑器并启动工作区。选择 File → Open，选取测试用的 .xlsx 文件。网页版本通过浏览器文件选择器读取文件，不会因此创建云端共享文档。`)
};

/**
* | output |
* | --- |
* | "Open the GridCraft editor and launch the workspace. Choose File → Open and select your test .xlsx file. The web build uses the browser’s file picker; opening..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_0(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_0(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_0 as "gc.search_guides.gridcraft_excel_compatibility.sections.1.steps.0" }